import React from "react";
import { Placeholder } from "@bloomberg/media-ui-article";
import { BookmarkOutline } from "@bloomberg/media.icons";
import styles from "./newsListItem.module.css";

interface NewsListItemSkeletonProps {
  readonly showDivider?: boolean;
}

export default function NewsListItemSkeleton({
  showDivider = true,
}: NewsListItemSkeletonProps) {
  return (
    <>
      <div className={styles.newsListItem}>
        <div className={styles.storyRow}>
          <Placeholder.Image className={styles.skeletonThumbnail} />
          <div className={styles.skeletonContent}>
            <div className={styles.skeletonCategory}>
              <Placeholder.Line />
            </div>
            <div className={styles.skeletonHeadline}>
              <Placeholder.Line />
            </div>
            <div className={styles.skeletonHeadline}>
              <Placeholder.Line />
            </div>
            <div className={styles.skeletonHeadline}>
              <Placeholder.Line />
            </div>
          </div>
        </div>

        <div className={styles.actionBar}>
          <div className={styles.skeletonTimestamp}>
            <Placeholder.Line />
          </div>
          <div className={styles.actionButtons}>
            <div className={styles.iconButton} aria-hidden="true">
              <BookmarkOutline />
            </div>
          </div>
        </div>
      </div>
      {showDivider ? <div className={styles.divider} /> : null}
    </>
  );
}
